import { useQuery } from '@apollo/react-hooks';
import React from 'react';
import { GET_CHANNELS_INFO } from '../../gql/channels';
import { IdAndName } from '../../shared/types';
import { ChannelLinkList } from './ChannelLinkList';

interface PremiumChannelsListProps {
    maxLength?: number;
    channelIdToExcludeFromList?: string;
}

const PremiumChannelList: React.FC<PremiumChannelsListProps> = ({
    maxLength,
    channelIdToExcludeFromList,
}) => {
    const { data: allChannelsData } = useQuery<{ channels: IdAndName[] }>(
        GET_CHANNELS_INFO,
        { fetchPolicy: 'network-only' }
    );
    const channels = allChannelsData?.channels ? allChannelsData.channels : [];

    const filteredChannels = channelIdToExcludeFromList
        ? channels.filter(
              (channel) => channel._id !== channelIdToExcludeFromList
          )
        : channels;

    const premiumChannels: IdAndName[] =
        maxLength && maxLength < filteredChannels.length
            ? filteredChannels.slice(0, maxLength)
            : filteredChannels;

    return <ChannelLinkList title="Channels" channels={premiumChannels} />;
};

export default PremiumChannelList;
